import * as React from 'react';
import { getConfig } from '@cian/config/browser';
import { FSKMortgageBanner } from '../../components/FSKMortgageBanner';
import { IFskBanner } from '../../types/fsk';
import { FSK_SP_BANNER } from '../../constants/specialProjects/fskSpecialProject';
import { sendFSKTeaserEvent } from '../../utils/analytics/sendFSKTeaserEvent';
import { trackingClickFSKMortgageBanner, trackingShowFSKMortgageBanner } from './tracking';

interface IFSKMortgageBannerContainerProps {
  isOpen?: boolean;
}

export function FSKMortgageBannerContainer({ isOpen }: IFSKMortgageBannerContainerProps) {
  const [bannerInfo, setBannerInfo] = React.useState<IFskBanner>(FSK_SP_BANNER);
  const bannerRef = React.useRef<HTMLAnchorElement>(null);
  const hitUrl = bannerRef.current?.href || '';

  React.useEffect(() => {
    const config = getConfig();

    setBannerInfo(config.get<IFskBanner>('fskBanner') || FSK_SP_BANNER);
  }, []);

  React.useLayoutEffect(() => {
    if (isOpen) {
      trackingShowFSKMortgageBanner();
      sendFSKTeaserEvent({ action: 'show', hitUrl, bannerPlace: 'top_menu_banner' });
    }
  }, [isOpen, hitUrl]);

  const handleBannerClick = React.useCallback(() => {
    trackingClickFSKMortgageBanner();
    sendFSKTeaserEvent({ action: 'click', hitUrl, bannerPlace: 'top_menu_banner' });
  }, [hitUrl]);

  return <FSKMortgageBanner bannerInfo={bannerInfo} onBannerClick={handleBannerClick} ref={bannerRef} />;
}
